import EditDashboardModal from './EditDashboardModal';

export default EditDashboardModal;
